import React from 'react';
import { connect } from 'react-redux';
import actions from '../../state/actions/multi-currency';
import MultiCurrencyDropdownLabel from './multi-currency-dropdown-label';

class MultiCurrencyMobileMenuButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, selectedCurrency } = this.props;

        const openSelector = () => {
            dispatch(actions.openMultiCurrencyMobile());
        };

        const selectedShortName = selectedCurrency
            ? selectedCurrency.shortName
            : '';
        const selectedLongName = selectedCurrency
            ? selectedCurrency.longName
            : '';

        return (
            <div
                className="multi-currency-selector-dropdown-trigger"
                onClick={openSelector}>
                <MultiCurrencyDropdownLabel
                    shortName={selectedShortName}
                    longName={selectedLongName}
                    showDownArrow={true}
                    showUpArrow={false}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        selectedCurrency: state.multiCurrency.preferredCurrency,
        ...ownProps
    };
};

export default connect(mapStateToProps)(MultiCurrencyMobileMenuButton);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-mobile-menu-button.jsx